import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import SellerServices from '../../services/SallerServices';
import UserServices from '../../services/UserServices';
function AddNewSeller() {
    const navigate = useNavigate();
    const [formValues, setFormValues] = useState({
        firstName: '',
        lastName: '',
        email: '',
        mobileNo: '',
        address: '',
        state: '',
        stateName: '',
        city: '',
        cityName: '',
        pincode: '',
        age: '',
        dob: '',
        doa: '',
        earningType: '',
        image: ""
    });

    const [loading, setLoading] = useState(false);
    const [imagePreview, setImagePreview] = useState(null);
    const [stateList, setStateList] = useState([]);
    const [cityList, setCityList] = useState([]);;
    const [loadingCities, setLoadingCities] = useState(false);
    // ✅ handle input
    const handleInputChange = (e) => {
        const { name, value } = e.target;

        if (name === 'stateName') {
            const selectedState = stateList.find(s => s.name === value);

            setFormValues(prev => ({
                ...prev,
                stateName: value,
                state: selectedState?._id || '',
                cityName: '',
                city: ''
            }));

            setCityList([]);

            if (selectedState?._id) {
                setLoadingCities(true);

                UserServices.getCities(selectedState._id)
                    .then(res => {
                        if (res.status && res.data) {
                            setCityList(res.data);
                        }
                    })
                    .catch(err => console.error(err))
                    .finally(() => setLoadingCities(false));
            }

        } else if (name === 'cityName') {

            const selectedCity = cityList.find(c => c.name === value);

            setFormValues(prev => ({
                ...prev,
                cityName: value,
                city: selectedCity?._id || ''
            }));

        }
        else if
              (name === 'mobileNo') {
        const onlyNumber = value.replace(/\D/g, '');

        if (onlyNumber.length <= 10) {
            setFormValues(prev => ({
                ...prev,
                mobileNo: onlyNumber
            }));
        }
              }
        
        
        else {
            setFormValues(prev => ({
                ...prev,
                [name]: value
            }));
        }
    };
    useEffect(() => {
        // Fetch states on component mount
        UserServices.getState().then(res => {
            console.log("States response:", res);
            if (res.status && res.data) {
                setStateList(res.data);
            }
        }).catch(error => {
            console.error("Error fetching states:", error);
        });
    }, []);
    // ✅ handle image
    const handleImageChange = (e) => {
        const file = e.target.files[0];

        if (file) {
            setFormValues((prev) => ({
                ...prev,
                image: file
            }));
            setImagePreview(URL.createObjectURL(file));
        }
    };
const handleMobileChange = (e) => {
    const value = e.target.value.replace(/\D/g, '');

    if (value.length <= 10) {
        setFormValues(prev => ({
            ...prev,
            mobileNo: value
        }));
    }
};
    // ✅ validation
    const validateForm = () => {
        const { firstName, email, mobileNo, stateName, cityName } = formValues;
        if (!firstName) return alert("First name required"), false;
        if (!email) return alert("Email required"), false;
        if (!mobileNo) return alert("Mobile required"), false;
        if (!stateName) return alert("State required"), false;
        if (!cityName) return alert("City required"), false;
        return true;
    };
    // ✅ submit
    const handleSubmit = async (event) => {
        event.preventDefault();
        // if (!validateForm()) return;
        setLoading(true);
        try {
            const formData = new FormData();
            Object.keys(formValues).forEach((key) => {
                formData.append(key, formValues[key]);
            });
            const res = await SellerServices.createSeller(formData);
            //    alert("Seller created successfully 🎉");
            //     navigate("/sallers");
            if (res?.status) {
                alert(res?.message);
                navigate("/sallers");
            } else {
                alert(res?.message);
            }

        } catch (error) {
            console.error("Error:", error);
            alert(error.response?.data?.message || "Failed to create seller");
        } finally {
            setLoading(false);
        }
    };

    // ✅ cleanup image memory
    useEffect(() => {
        return () => {
            if (imagePreview) URL.revokeObjectURL(imagePreview);
        };
    }, [imagePreview]);

    return (
        <>
            <div className="right_col" role="main">
                <div className="d-md-flex align-items-center justify-content-between my-4 page-header-breadcrumb">
                    <div className="my-auto">
                        <h5 className="page-title fs-21 mb-1">
                            Add New Seller
                        </h5>
                        <nav>
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item">
                                    <a href="javascript:void(0);">Home</a>
                                </li>
                            </ol>
                        </nav>
                    </div>
                    <div className="d-flex my-xl-auto gap-2 right-content align-items-center">
                        <Link className="list-banner-btn" to="/sallers">Seller List</Link>
                    </div>
                </div>

                <div className="container-box">
                    <div className="container-box-inner table-reponsive-tabe">
                        <div className="page-details">

                            <form onSubmit={handleSubmit}>
                                <div className="row">

                                    {/* First Name */}
                                    <div className="col-lg-6 col-sm-12">
                                        <div className="input-field">
                                            <label>First Name<span className="red">*</span></label>
                                            <input
                                                type="text"
                                                name="firstName"
                                                className="form-control"
                                                value={formValues.firstName}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                    </div>

                                    {/* Last Name */}
                                    <div className="col-lg-6 col-sm-12">
                                        <div className="input-field">
                                            <label>Last Name</label>
                                            <input
                                                type="text"
                                                name="lastName"
                                                className="form-control"
                                                value={formValues.lastName}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                    </div>

                                    {/* Email */}
                                    <div className="col-lg-6 col-sm-12">
                                        <div className="input-field">
                                            <label>Email<span className="red">*</span></label>
                                            <input
                                                type="email"
                                                name="email"
                                                className="form-control"
                                                value={formValues.email}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                    </div>

                                    {/* Mobile */}
                                    <div className="col-lg-6 col-sm-12">
                                        <div className="input-field">
                                            <label>Mobile<span className="red">*</span></label>
                                            <input
                                                type="number"
                                                name="mobileNo"
                                                maxLength={10}
                                                className="form-control"
                                                value={formValues.mobileNo}
                                                onChange={handleInputChange}
                                                handleMobileChange
                                            />
                                        </div>
                                    </div>

                                    {/* Address */}
                                    <div className="col-lg-12 col-sm-12">
                                        <div className="input-field">
                                            <label>Address</label>
                                            <input
                                                type="text"
                                                name="address"
                                                className="form-control"
                                                value={formValues.address}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-sm-12">
                                        <div className="input-field">
                                            <label>State<span className="red">*</span></label>
                                            <select
                                                name="stateName"
                                                className="form-control"
                                                value={formValues.stateName}
                                                onChange={handleInputChange}

                                            >
                                                <option value="">Select State</option>
                                                {stateList.map((s) => (
                                                    <option key={s._id} value={s.name}>
                                                        {s.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-sm-12">
                                        <div className="input-field">
                                            <label>City<span className="red">*</span></label>
                                            <select
                                                name="cityName"
                                                className="form-control"
                                                value={formValues.cityName}
                                                onChange={handleInputChange}
                                            >
                                                <option value="">
                                                    {loadingCities ? "Loading cities..." : "Select City"}
                                                </option>
                                                {cityList.map((c) => (
                                                    <option key={c._id} value={c.name}>
                                                        {c.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    {/* Pincode */}
                                    <div className="col-lg-6 col-sm-12">
                                        <div className="input-field">
                                            <label>Pincode</label>
                                            <input
                                                type="number"
                                                name="pincode"
                                                className="form-control"
                                                value={formValues.pincode}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                    </div>

                                    {/* Age */}
                                    <div className="col-lg-6 col-sm-12">
                                        <div className="input-field">
                                            <label>Age</label>
                                            <input
                                                type="number"
                                                name="age"
                                                className="form-control"
                                                value={formValues.age}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                    </div>

                                    {/* DOB */}
                                    <div className="col-lg-6 col-sm-12">
                                        <div className="input-field">
                                            <label>DOB</label>
                                            <input
                                                type="date"
                                                name="dob"
                                                className="form-control"
                                                value={formValues.dob}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                    </div>

                                    {/* DOA */}
                                    <div className="col-lg-6 col-sm-12">
                                        <div className="input-field">
                                            <label>DOA</label>
                                            <input
                                                type="date"
                                                name="doa"
                                                className="form-control"
                                                value={formValues.doa}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                    </div>

                                    {/* Earning Type */}
                                    <div className="col-lg-6 col-sm-12">
                                        <div className="input-field">
                                            <label>Earning Type</label>
                                            <select
                                                name="earningType"
                                                className="form-control"
                                                value={formValues.earningType}
                                                onChange={handleInputChange}
                                            >
                                                <option value="">Select</option>
                                                <option value="Salary">Salary</option>
                                                <option value="Commission">Commission</option>
                                                <option value="Both">Both</option>
                                            </select>
                                        </div>
                                    </div>
                                    {/* Image */}
                                    <div className="col-lg-6 col-sm-6">
                                        <div className="input-field">
                                            <label>Image:</label>
                                            <input
                                                type="file"
                                                className="form-control"
                                                accept="image/*"
                                                onChange={handleImageChange}
                                            />
                                            {imagePreview && (
                                                <div style={{ marginTop: "10px" }}>
                                                    <img
                                                        src={imagePreview}
                                                        alt="Preview"
                                                        style={{
                                                            width: "150px",
                                                            height: "150px",
                                                            objectFit: "cover",
                                                            borderRadius: "8px",
                                                            border: "1px solid #ccc"
                                                        }}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                </div>

                                <div className="text-center mt-4">
                                    <button
                                        className="submit-green-btn"
                                        type="submit"
                                        disabled={loading}
                                        style={{ minWidth: '150px' }}
                                    >
                                        {loading ? 'SUBMITTING...' : 'SUBMIT'}
                                    </button>
                                </div>

                            </form>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AddNewSeller;